export default "__VITE_ASSET__C9gkJKvs__";